export default "__VITE_ASSET__Cq9Yag7B__"